import React, { useState } from "react";
import Modalform from "../Formularz/Modalform";

import "./PlanyTD.css";
import MiniNav from "../../components/Navbar/MiniNav";

const TreningP = () => {
    const [openModal, setOpenModal] = useState(false);

    return (
        <>
            <MiniNav />
            <div className="app__bg section__padding">
                <div className="app__plantd">
                    <div className="app__plantd-menu1">
                        <p className="app__menu_heading">Plan Treningowy</p>
                        <ul className="white">
                            <li>Wstępna konsultacja treningowa</li>
                            <li>Plan dostosowany pod Twój cel treningowy</li>
                        </ul>
                        <div className="btn_plantd1">
                            <button
                            onClick={() => setOpenModal(true)}
                                type="button"
                                className="customm__plantd_btn"
                            >
                                Poznaj ofertę
                            </button>
                            <Modalform
                                open={openModal}
                                onClose={() => setOpenModal(false)}
                            />
                        </div>
                    </div>

                    <div className="app__plantd-menu2">
                        <p
                            style={{
                                background: "red",
                                color: "white",
                                textAlign: "center",
                            }}
                        >
                            Najczęściej wybierany
                        </p>
                        <p className="app__menu_heading">
                            Miesięczna współpraca dietetyczna
                        </p>
                        <ul className="white">
                            <li>Wstępna konsultacja dietetyczna</li>
                            <li>
                                Spersonalizowany jadłospis dostosowany do Twoich
                                preferencji żywieniowych z możliwością
                                wprowadzania nieograniczonych poprawek + lista
                                zakupów
                            </li>
                            <li>
                                Regularne monitorowanie Twoich efektów i analiza
                                postępów
                            </li>
                            <li>Stały kontakt</li>
                            <li>
                                Możliwość pomiaru na analizatorze składu ciała
                                InBody
                            </li>
                        </ul>
                        <div className="btn_plantd2">
                        <button
                            onClick={() => setOpenModal(true)}
                                type="button"
                                className="customm__plantd_btn"
                            >
                                Poznaj ofertę
                            </button>
                            <Modalform
                                open={openModal}
                                onClose={() => setOpenModal(false)}
                            />
                        </div>
                    </div>

                    <div className="app__plantd-menu3">
                        <p className="app__menu_heading">Plan dietetyczny</p>
                        <ul className="white">
                            <li>Wstępna konsultacja dietetyczna</li>
                            <li>
                                Indywidualny plan dietetyczny dostosowany do
                                Twoich celów i preferencji żywieniowe + lista zakupów
                            </li>
                            <li>Plan na okres 7 lub 10 dni</li>
                        </ul>
                        <div className="btn_plantd3">
                        <button
                            onClick={() => setOpenModal(true)}
                                type="button"
                                className="customm__plantd_btn"
                            >
                                Poznaj ofertę
                            </button>
                            <Modalform
                                open={openModal}
                                onClose={() => setOpenModal(false)}
                            />
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
};

export default TreningP;
